module.exports = __webpack_public_path__ + "img/handyman.team.16307679.png";